export default Object.prototype.hasOwnProperty.call.bind(Object.prototype.hasOwnProperty)
